import $ from "jquery";

class SelectWrapper {
  constructor(el) {
    this.$el =  $(el);

    this._init();
  }

  _init() {
    const $currentOption =
      this.$el.find('option[selected]').length
      ? this.$el.find('option[selected]')
      : this.$el.find('option:first');

    if (this.$el.parent('.form-select').length === 0) {
      this.$el.wrap('<div class="form-select"></div>');
    }

    this.$parent = this.$el.parent();
    this.$wrapper = this.$el.closest('.form-select-wrapper');

    if (this.$parent.find('.form-selected-text').length === 0) {
      this.$el.before(`<span class="form-selected-text">${$currentOption.text()}</span>`);
    }

    this._bindEvents();
  }

  _bindEvents() {
    this.$el.on('change.selectPlugin', () => {
      this._updateSelectText();
    });
  }

  _updateSelectText(option) {
    const newOption = option ? option : this.$el.find('option:selected').text();
    this.$el.siblings('.form-selected-text').text(newOption);
  }
}

$(() => {
  const $select = $('.simple_form select:not([multiple])');

  if ($select.length) {
    $select.each((i, el) => {
      let select = new SelectWrapper(el);
    });
  }

  if ($('.form-select-wrapper.date').length && $('.form-select').parent('.form-select-outer').length === 0) {
    $('.form-select-wrapper.date').each((i, el) => {
      $(el).find('.form-select').wrapAll('<div class="form-select-outer"></div>');
    });
  }
});
